import { getVehicle } from 'Services/api/vehicles';
import type { Nullable } from 'Types/utils';
import type { VehicleListItem } from 'Types/vehicle';

export const selectedVehicleFetcher = async (
	vehicleId?: VehicleListItem['id'],
): Promise<Nullable<VehicleListItem[]>> => {
	if (!vehicleId) {
		return null;
	}

	return getVehicle<VehicleListItem[]>({
		isSchemaForList: true,
		vehicleId,
	});
};
